<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {
      num: 1800,
      timmer: "",
    };
  },
  methods: {
    loginOut() {
      localStorage.removeItem("info");
      location.reload();
      done();
    },
    change() {
      this.num = 1800;
    },
  },

  created() {
    console.log("开始");
    this.timmer = setInterval(() => {
      this.num--;
     // console.log(this.num);
      if (this.num == 0) {
        console.log("结束");

        this.loginOut();
      }
    }, 1000);

    document.body.addEventListener("touchstart", this.change);
    document.body.addEventListener("click", this.change);
  },
};
</script>

<style lang="scss" scoped></style>
